module.exports = __webpack_public_path__ + "img/image_004.a7ca6fa9.jpeg";